/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { useObjectRef } from '@react-aria/utils';
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef, useContext } from 'react';
import {
  Collection,
  CollectionBuilder,
  CollectionRendererContext,
  type ContextValue,
  useContextProps
} from 'react-aria-components';

interface ListProps extends Omit<HTMLAttributes<HTMLElement>, 'style' | 'className'> {
  /** Whether the list is ordered. (Default: false) */
  isOrdered?: boolean;
  style?: stylex.StyleXStyles;
  items?: Iterable<object>;
  dependencies?: unknown[];
}

const ListContext = createContext<ContextValue<ListProps, HTMLUListElement | HTMLOListElement>>({});

const List = forwardRef((props: ListProps, ref: ForwardedRef<HTMLUListElement | HTMLOListElement>) => {
  [props, ref] = useContextProps(props, ref, ListContext);

  const { style, isOrdered = false, children, items, dependencies, ...coreProps } = props;

  const listRef = useObjectRef(ref as ForwardedRef<HTMLOListElement>);
  const { CollectionRoot } = useContext(CollectionRendererContext);

  const Element = isOrdered ? 'ol' : 'ul';

  return (
    <CollectionBuilder content={<Collection items={items} dependencies={dependencies}>{children}</Collection>}>
      {(collection) => (
        <Element
          ref={listRef}
          {...stylex.props(styles.base, style)}
          {...coreProps}>
          <CollectionRoot collection={collection} scrollRef={listRef} />
        </Element>
      )}
    </CollectionBuilder>
  );
});

const styles = stylex.create({
  base: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
});

export { List, ListContext, type ListProps };
